import React from 'react';
import { motion } from 'framer-motion';

export default function TestimonialStrip({ testimonials }) {
  if (!testimonials || testimonials.length === 0) return null;

  const featured = testimonials.slice(0, 2);
  const avg = (testimonials.reduce((s, t) => s + (t.rating || 5), 0) / testimonials.length).toFixed(1);

  return (
    <section className="bg-[#EFE7D6] text-[#0B0B0B]" data-testid="testimonial-strip">
      <div className="container mx-auto max-w-6xl px-6 py-12 grid md:grid-cols-3 gap-8 items-center">
        {featured.map((t, i) => (
          <motion.div
            key={t.id || i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className={featured.length === 1 ? 'md:col-span-2' : ''}
            data-testid={`strip-testimonial-${i}`}
          >
            <div className="flex items-start gap-4">
              {t.image_url ? (
                <img src={t.image_url} alt={t.name} className="w-12 h-12 rounded-full object-cover shrink-0" />
              ) : (
                <div className="w-12 h-12 rounded-full bg-[#0B0B0B] text-[#C6A97C] flex items-center justify-center font-bold shrink-0">
                  {t.name.charAt(0)}
                </div>
              )}
              <div>
                <p className="text-sm sm:text-base leading-relaxed mb-2">"{t.content}"</p>
                <div className="text-sm font-semibold">— {t.name}{t.role ? `, ${t.role}` : ''}</div>
              </div>
            </div>
          </motion.div>
        ))}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="md:border-l md:border-[#0B0B0B]/10 md:pl-8"
        >
          <div className="font-semibold mb-1">Trusted by active people just like you.</div>
          <div className="flex items-center gap-2">
            <span className="text-[#B7935B] tracking-tight">★★★★★</span>
            <span className="text-sm text-[#0B0B0B]/60">{avg}/5 rating</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
